import React from "react";
import {FixedBottom} from 'react-fixed-bottom';
import styled from 'styled-components';

export function XBEconfMobile({
  handleFilter,
  checkIfShow,
  children
}) {


  const handleF = (f) => {
    var element = document.getElementById("cards");
    element.scrollIntoView({behavior: "smooth", inline: "nearest"});
    handleFilter(f)
  }


  return (
    <CssFixedBottom offset={-44}>
      <div className="x_cat_mobile-filters"
        style={{
          // paddingBottom: 64,
          // marginBottom: -24,
          // background: 'white',
        }}
      >

        <div className="x_cat_mobright noclick" />
        <div className="x_cat0">
          <div className="x_cat_col">
            <div className="x_cat_decal0">
              <div className="x_cat_decal_inner">
                <div className="x_cat_decal_h x_cat_decal_h--dark">
                  <div>Stage</div>
                </div>
                <div className="x_cat_decal" />
              </div>
            </div>
            <div className="x_cat_sel0 x_cat_sel0--v">


              <div
                onClick={() => { handleF('all'); }}
                className={`x_catnew_item ${checkIfShow('all') ? 'active' : ''}`}
              >
                <div>
                  <div>All stages</div>
                </div>
              </div>


              <div
                onClick={() => { handleF('pre_launch'); }}
                className={`x_catnew_item ${checkIfShow('pre_launch') ? 'active' : ''}`}
              >
                <div className="l_line_li">
                  <div>Pre-launch</div>
                </div>
                <div className="x_catnew_next" />
              </div>


              <div
                onClick={() => { handleF('early_access'); }}
                className={`x_catnew_item ${checkIfShow('early_access') ? 'active' : ''}`}
              >
                <div className="l_line_li">
                  <div>Early access</div>
                </div>
                <div className="x_catnew_next" />
              </div>


              <div
                onClick={() => { handleF('live_game'); }}
                className={`x_catnew_item ${checkIfShow('live_game') ? 'active' : ''}`}
              >
                <div className="l_line_li">
                  <div>Live game</div>
                </div>
              </div>

            </div>
          </div>
          <div className="x_catnew_col">
            <div className="x_cat_decal0">
              <div className="x_cat_decal_inner">
                <div className="x_cat_decal_h x_cat_decal_h--dark">
                  <div>Monetization</div>
                </div>
                <div className="x_cat_decal" />
              </div>
            </div>
            <div className="l_line_li">
              <div className="x_cat_sel0 x_cat_sel0--v">


              <div
                onClick={() => { handleF('premium'); }}
                className={`x_catnew_item ${checkIfShow('premium') ? 'active' : ''}`}
              >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li">
                    <div>
                      <div>Premium</div>
                    </div>
                  </div>
              </div>


              <div
                onClick={() => { handleF('microtransactions'); }}
                className={`x_catnew_item ${checkIfShow('microtransactions') ? 'active' : ''}`}
              >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li">
                    <div>
                      <div>Microtransactions</div>
                    </div>
                  </div>
                </div>


                <div
                  onClick={() => { handleF('subscriptions'); }}
                  className={`x_catnew_item ${checkIfShow('subscriptions') ? 'active' : ''}`}
                >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li">
                    <div>Subscriptions</div>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div className="x_catnew_col">
            <div className="x_cat_decal0">
              <div className="x_cat_decal_inner">
                <div className="x_cat_decal_h x_cat_decal_h--dark">
                  <div>Platform</div>
                </div>
                <div className="x_cat_decal" />
              </div>
            </div>


            <div className="l_line_li">
              <div className="x_cat_sel0 x_cat_sel0--v">


                <div
                  onClick={() => { handleF('pc_mac'); }}
                  className={`x_catnew_item ${checkIfShow('pc_mac') ? 'active' : ''}`}
                >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li l_line--xs">
                    <div>
                      <div>PC/Mac</div>
                    </div>
                  </div>
                </div>


                <div
                  onClick={() => { handleF('web'); }}
                  className={`x_catnew_item ${checkIfShow('web') ? 'active' : ''}`}
                >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li l_line--xs">
                    <div>
                      <div>Web</div>
                    </div>
                  </div>
                </div>


                <div
                  onClick={() => { handleF('mobile'); }}
                  className={`x_catnew_item ${checkIfShow('mobile') ? 'active' : ''}`}
                >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li l_line--xs">
                    <div>
                      <div>Mobile</div>
                    </div>
                  </div>
                </div>

                <div
                  onClick={() => { handleF('console'); }}
                  className={`x_catnew_item ${checkIfShow('console') ? 'active' : ''}`}
                >
                  <div className="x_cat_itemnew_check">
                    <div className="x_cat_item_check w-embed">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 11.6616L11.1319 16.9994L20.1841 7.52245"
                          stroke="#FFF"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="l_line_li l_line--xs">
                    <div>
                      <div>Console</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CssFixedBottom>
  );
}


const CssFixedBottom = styled(FixedBottom)`
  z-index: 100;
`





export function XBEconfMobile2({
  handleF,
  checkIfShow,
  children
}) {
  return (


    <FixedBottom  offset={-44}>

    <div className="x_cat_mobile-filters" style={{zIndex: 100, width: '100%'}}>
      <div className="x_cat_mobile-h">
        <div>
          <div>
            <strong>
              Select the details below that best describe your game
              </strong>
          </div>
        </div>
      </div>
      <div className="x_cat0">
        <div className="x_cat_col">
          <div className="x_cat_decal0">
            <div className="x_cat_decal_inner">
              <div className="x_cat_decal_h">
                <div>Stage</div>
              </div>
              <div className="x_cat_decal" />
            </div>
          </div>
          <div className="x_cat_filt_inner">


              <div onClick={() => { handleF('all'); }} className={`x_cat_item x_cat_item_or x_cat_item--all x_cat_item--mob ${checkIfShow('all') ? 'x_cat_item--active' : ''}`}>
                <div className="x_sol_cardsul x_sol_cardsul--active">
                <div className="x_cat_type_h">All stages</div>
                </div>
              <div className="x_cat_item_active">


              </div>
            </div>


            <div onClick={() => { handleF('pre_launch'); }} className={`x_cat_item x_cat_item_or x_cat_item_next x_cat_item--mob ${checkIfShow('pre_launch') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_cat_type_h">Pre-launch</div>
              </div>
              <div className="x_cat_item_active">


              </div>
            </div>

            <div onClick={() => { handleF('early_access'); }} className={`x_cat_item x_cat_item_or x_cat_item_next x_cat_item--mob ${checkIfShow('early_access') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_cat_type_h">Early access</div>
              </div>
              <div className="x_cat_item_active">


              </div>
            </div>


            <div onClick={() => { handleF('live_game'); }} className={`x_cat_item x_cat_item_or x_cat_item--mob ${checkIfShow('live_game') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_cat_type_h">Live game</div>
              </div>
              <div className="x_cat_item_active">


              </div>
            </div>
          </div>
        </div>
        <div className="x_cat_col">
          <div className="x_cat_decal0">
            <div className="x_cat_decal_inner">
              <div className="x_cat_decal_h">
                <div>Monetization</div>
              </div>
              <div className="x_cat_decal" />
            </div>
          </div>
          <div className="x_cat_filt_inner">

            <div onClick={() => { handleF('premium'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('premium') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_sol_cardsul x_sol_cardsul--active">
                  <div className="x_cat_type_h">Premium</div>
                </div>
              </div>
              <div className="x_cat_item_active">
                <div className="x_cat_item_check w-embed">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                  </svg>
                </div>
              </div>
            </div>

            <div onClick={() => { handleF('microtransactions'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('microtransactions') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_sol_cardsul x_sol_cardsul--active">
                  <div className="x_cat_type_h x_sol_cardsul--active">
                    Microtransactions
                    </div>
                </div>
              </div>
              <div className="x_cat_item_active">
                <div className="x_cat_item_check w-embed">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                  </svg>
                </div>
              </div>
            </div>


            <div onClick={() => { handleF('subscriptions'); }} className={`x_cat_item ${checkIfShow('subscriptions') ? 'x_cat_item--active' : ''}`}>
              <div className="l_line_li">
                <div className="x_cat_type_h">Subscriptions</div>
              </div>
              <div className="x_cat_item_active">
                <div className="x_cat_item_check w-embed">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="x_cat_col">
          <div className="x_cat_decal0">
            <div className="x_cat_decal_inner">
              <div className="x_cat_decal_h">
                <div>Platform</div>
              </div>
              <div className="x_cat_decal" />
            </div>
          </div>
          <div className="l_line_li">
            <div className="x_cat_filt_inner">

            <div onClick={() => { handleF('pc_mac'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('pc_mac') ? 'x_cat_item--active' : ''}`}>
                <div className="l_line_li l_line--xs">
                  <div className="x_sol_cardsul x_sol_cardsul--active">
                    <div className="x_cat_type_h">PC/Mac</div>
                  </div>
                </div>
                <div className="x_cat_item_active">
                  <div className="x_cat_item_check w-embed">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                    </svg>
                  </div>
                </div>
              </div>


              <div onClick={() => { handleF('web'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('web') ? 'x_cat_item--active' : ''}`}>
                <div className="l_line_li l_line--xs">
                  <div className="x_sol_cardsul x_sol_cardsul--active">
                    <div className="x_cat_type_h">Web</div>
                  </div>
                </div>
                <div className="x_cat_item_active">
                  <div className="x_cat_item_check w-embed">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                    </svg>
                  </div>
                </div>
              </div>


              <div onClick={() => { handleF('mobile'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('mobile') ? 'x_cat_item--active' : ''}`}>
                <div className="l_line_li l_line--xs">
                  <div className="x_sol_cardsul x_sol_cardsul--active">
                    <div className="x_cat_type_h">Mobile</div>
                  </div>
                </div>
                <div className="x_cat_item_active">
                  <div className="x_cat_item_check w-embed">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                    </svg>
                  </div>
                </div>
              </div>


              <div onClick={() => { handleF('console'); }} className={`x_cat_item x_cat_item--mob ${checkIfShow('console') ? 'x_cat_item--active' : ''}`}>
                <div className="l_line_li l_line--xs">
                  <div className="x_sol_cardsul x_sol_cardsul--active">
                    <div className="x_cat_type_h">Console</div>
                  </div>
                </div>
                <div className="x_cat_item_active">
                  <div className="x_cat_item_check w-embed">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </FixedBottom>

  );
}
